import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { ILevelData } from "common/records/Level";

export const FETCH_LEVEL = "@level/FETCH_LEVEL";
export const RECEIVE_LEVEL = "@level/RECEIVE_LEVEL";
export const RECEIVE_LEVELS = "@level/RECEIVE_LEVELS";
export const RESET_LEVEL = "@level/RESET_LEVEL";
export const SET_LEVEL_LOADED = "@level/SET_LEVEL_LOADED";
export const DESTROY_LEVEL = "@level/DESTROY_LEVEL";
export const REMOVE_LEVEL = "@level/REMOVE_LEVEL";
export const ACTIVATE_LEVEL = "@level/ACTIVATE_LEVEL";

export const LevelActions = {
  fetchLevel: (levelId: string | number) => createAction(FETCH_LEVEL, { levelId }),
  receiveLevel: (level: ILevelData, pushToList?: boolean) => createAction(RECEIVE_LEVEL, { level, pushToList }),
  receiveLevels: (levels: ILevelData[]) => createAction(RECEIVE_LEVELS, { levels }),
  resetLevel: (levelId: string | number) => createAction(RESET_LEVEL, { levelId }),
  setLevelLoaded: (levelId: string | number) => createAction(SET_LEVEL_LOADED, { levelId }),
  destroyLevel: (levelId: string | number) => createAction(DESTROY_LEVEL, { levelId }),
  removeLevel: (levelId: string | number) => createAction(REMOVE_LEVEL, { levelId }),
  activateLevel: (levelId: string | number) => createAction(ACTIVATE_LEVEL, { levelId }),
};

export type LevelActions = ActionsUnion<typeof LevelActions>;
